import { zodResolver } from '@hookform/resolvers/zod'
import { useCallback } from 'react'
import { useForm } from 'react-hook-form'

import { Button } from '~/components/Button'
import { TextInput } from '~/components/TextInput'

import { FormType, schema } from './schema'

type Props = {
  exerciseGroup: string
}

export const NewExerciseForm: React.FC<Props> = ({ exerciseGroup }) => {
  const form = useForm<FormType>({
    defaultValues: {
      exerciseGroup,
    },
    resolver: zodResolver(schema),
  })

  const onFormSubmit = useCallback(async () => {
    form.resetField('exercise')
  }, [form])

  return (
    <form onSubmit={form.handleSubmit(onFormSubmit)}>
      <div className='flex flex-wrap items-center gap-3'>
        <TextInput
          {...form.register('exercise')}
          label='Caso queira, você também pode adicionar novos exercício a esta lista'
          placeholder='Novo Exercício'
          error={form.formState.errors.exercise?.message}
        />
        <div className='mt-5'>
          <Button>Adicionar</Button>
        </div>
      </div>
    </form>
  )
}
